<template>
  <div class="paymentSuccess" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="flow_main" v-if="payResult">
        <p>
          <img src="../../assets/icon/su.svg">
          <span>支付成功</span>
        </p>
        <p>實付款： ¥ {{params.amount}}</p>
        <p class="reBtn">
          <router-link :to="{name:'ProductPage'}" tag="button" >繼續購物</router-link>
          <router-link :to="{name:'MyOrder'}" tag="button" >查看訂單</router-link>
        </p>
      </div>
      <div class="payFail" v-else>
        <h3 style="font-size: 20px;">系统信息</h3>
        <div style="margin: 20px auto;">
          <p class="word-information">{{ errorMessage }}</p>
        </div>
        <p style="display:inline-block;" >
          <a class="btn btn-primary" href="javascript:history.back(-1)">返回上一页</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  //api
  import {orderPayQuery} from '@/api/order';
  export default {
    name: 'PaymentSuccess',
    data () {
      return {
        params:{
          orderid:this.$route.query.orderid,
          amount:this.$route.query.amount,
        },
        amount:'0.00',
        payResult: true,
        errorMessage: ''
      }
    },
    methods:{

    },
    created(){
      window.scrollTo(0,0)
    },
    mounted(){
      var _this = this
      window.addEventListener("popstate", function(e) { // 监听返回键
        _this.$router.push({
          name:'MyOrder'
        })
      }, false);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.word-information{
    color: #8b8b8b;
    background-color: #f7f7f7;
    padding: 50px 10px;
    font-size: 18px;
    line-height: 36px;
}
.btn-primary{
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
 .paymentSuccess{
   .flow_main{
     height: 282px;
     width: 100%;
     padding: 20px 99px;
     border:2px solid #40af34;
     margin-bottom: 100px;
     text-align: center;
     p{
       margin-top:20px;
       color: #40af34;
       font-size:16px;
       img{
         width: 60px;
         height: 60px;
         margin-right: 10px;
       }
       span{
         font-size: 34px;
         font-weight: bold;
         text-align: center;
         vertical-align: middle;
       }
       button{
         background: red;
         color: #fff;
         display: inline-block;
         width: 130px;
         height: 35px;
         border-radius: 5px;
         margin: 0 10px;
         transition: all 0.1s linear;
         &:hover{
            background: #ff4850;
          }
       }
     }
     .reBtn{
       margin-top: 60px;
     }
   }
   .payFail{
     height: 282px;
     text-align: center;
     width: 100%;
   }
 }
</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/PaymentSuccess.vue